import Button from '@mui/material/Button'
import queryString from 'query-string'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled from '@emotion/styled'
import config from '../../config'
import { theme, reportError } from 'j-comps'
import { Helmet } from 'react-helmet'
import { store } from '../..'

const LoginViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`

const LoginContainer = styled.div`
  padding: ${theme.spacing.medium};
  text-align: center;
`
const RegisterContainer = styled.div``

const RegisterLink = styled.a`
  text-decoration: none;
  color: ${theme.color.accents.primary};
`

const mapStateToProps = (state) => ({
  isLoggedInVendor: state.isLoggedInVendor,
})

const LoginComponent = connect(mapStateToProps)(
  withRouter(({ history, location }) => {
    function getTokensFromLocalStorage() {
      try {
        const at = queryString.parse(location.search).at
        const rt = queryString.parse(location.search).rt
        if (at && rt) {
          localStorage.setItem(
            `${config.vendor.name.lowerCase}_access_token`,
            at
          )
          localStorage.setItem(
            `${config.vendor.name.lowerCase}_refresh_token`,
            rt
          )
          window.opener.location.reload()
          window.close()
        }
      } catch (error) {
        const errorMessage = 'Could not set token(s)'
        reportError(store, errorMessage, error)
      }
    }
    if (localStorage.getItem(`${config.vendor.name.lowerCase}_access_token`)) {
      history.push({
        pathname: '/',
      })
    }

    function handleClick() {
      window.open(config.vendor.login.url)
    }

    useEffect(() => {
      getTokensFromLocalStorage()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
      <LoginViewContainer>
        <Helmet>
          <title>{config.vendor.name.titleCase} - Login</title>
        </Helmet>
        <LoginContainer>
          <Button variant={'outlined'} size={'large'} onClick={handleClick}>
            Login to {config.vendor.name.titleCase}
          </Button>

          <RegisterContainer>
            <p>Don't have an account?</p>
            <p>
              <RegisterLink
                target={'_blank'}
                href={config.vendor.register.url}
                rel={'noreferrer noopener'}
              >
                Create an account
              </RegisterLink>
            </p>
          </RegisterContainer>
        </LoginContainer>
      </LoginViewContainer>
    )
  })
)

const Login = () => {
  return <LoginComponent />
}

export default Login
